import axios from "axios";

const hibpApi = axios.create({
    baseURL: 'https://passwordrubata.com/sitn',
    withCredentials: false,
    headers: {
        'pw-token': 'ttz23880du2jk43ii2b668925hh26',
    }
})

export const acApi = axios.create({
    baseURL: 'https://powerb61933.api-us1.com/api/3',
    headers: {
        'Api-Token': process.env.VUE_APP_AC_KEY
    }
})

export const hibp2 = axios.create({
    baseURL: 'https://haveibeenpwned.com/api/v3/breachedaccount',
})

export default hibpApi